import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from 'src/ui/library/Autocomplete';
import ContentParser from 'src/ui/library/ContentParser';
import { transformFormValues } from 'src/helpers';
import { withSnackbar } from 'notistack';
import intl from 'react-intl-universal';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import Button from 'src/ui/library/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { components } from 'react-select';
import serviceUrls from 'src/constants/serviceUrls';
import axios from 'axios';
import WarningIcon from '@material-ui/icons/Warning';
import { EMAIL_REGEX, EMAIL_ATTRIBUTE, PHONE_ATTRIBUTE, PHONE_REGEX } from '../../../constants/constants';
import _ from 'lodash';

class SearchAdd extends React.Component {
  constructor(props) {
    super(props);
    this.onValidate = this.onValidate.bind(this);
  }
  static propTypes = {
    /** Classname to be applied to <TableLanding> */
    className: PropTypes.string,
    /** Pre-defined custom styles to override <AutocompleteBase /> */
    styleType: PropTypes.string,
    /** Default AutoComplete value. Should be the same object structure used in the `onSearch` array results */
    defaultValue: PropTypes.object,
    /** Label used for the add footer button */
    addLabel: PropTypes.string,
    /** Label used for the AutoComplete search input */
    searchLabel: PropTypes.string,
    /** Label used for the cancel form action button */
    cancelLabel: PropTypes.string,
    /** Label used for the save form action button */
    saveLabel: PropTypes.string,
    /** Form elements used for 'Add' -- content should follow FormEngine structure */
    formElements: PropTypes.object.isRequired,
    /** Function used to filter AutoComplete results */
    onFilter: PropTypes.func.isRequired,
    /** Promise used to populate the <AutoComplete /> */
    onSearch: PropTypes.func.isRequired,
    /** Promise called to save formData from <ContentParser /> */
    onSaveForm: PropTypes.func.isRequired,
    /** Callback function triggered on sucessful save from onSaveForm */
    onSaveSuccess: PropTypes.func,
    /** Callback function used to modify payload */
    onModifySaveRequest: PropTypes.func,
    /** Callback fired when a Dropdown value is selected or a new user is filled out and saved */
    onChange: PropTypes.func,
    /** Function to get dropdown option value */
    getOptionValue: PropTypes.func,
  };

  static defaultProps = {
    addLabel: '+ Add',
    searchLabel: 'Search',
    cancelLabel: 'Cancel',
    saveLabel: 'Save',
    noResultsLabel: 'No Results',
    defaultValue: null,
    styleType: 'addEmployee',
  };

  state = {
    value: null,
    isFormShown: false,
    formValues: null,
    isFormComplete: false,
    saveDisabled: false,
    isDuplicateUserSelected: false,
    duplicateUserSelected: {},
    duplicateEmployeeArray: [],
    duplicateEmployee: false,
    isEmailValid: false,
    isPhoneValid: false,
    isHomePhoneValid: false,
  };

  setFormStatus = status => {
    this.setState({ isFormShown: status });
  };

  handleOnChange = value => {
    // Check for empty array as that is what is returned when cleared
    // Set to null if so to avoid issues in Content Parser
    let valueToSet = value && value.length === 0 ? null : value;
    this.setState({ valueToSet }, () => {
      if (this.props.onChange) {
        this.props.onChange(valueToSet);
      }
    });
  };

  onValidate(fields, setErrorFn) {
    const { emailaddress1, telephone1, telephone2 } = fields;
    const pageElement = _.get(this.props, 'formElements.pageElements');
    let isEmailMandatory = false;
    let isPhoneMandatory = false;
    let isHomePhoneMandatory = false;
    let pageObj = _.find(pageElement, e => e.attributeName !== null && e.attributeName.toLowerCase() === EMAIL_ATTRIBUTE.ATTRIBUTE_NAME);
    let phoneObj = _.find(pageElement, e => e.attributeName !== null && e.attributeName.toLowerCase() === PHONE_ATTRIBUTE.ATTRIBUTE_NAME);
    let homePhoneObj = _.find(
      pageElement,
      e => e.attributeName !== null && e.attributeName.toLowerCase() === PHONE_ATTRIBUTE.HOME_PHONE_ATTRIBUTE_NAME,
    );
    isEmailMandatory = pageObj && pageObj.mandatory;
    isPhoneMandatory = phoneObj && phoneObj.mandatory;
    isHomePhoneMandatory = homePhoneObj && homePhoneObj.mandatory;
    if (isEmailMandatory) {
      if (emailaddress1) {
        this.emailValidation(emailaddress1, setErrorFn);
      }
    } else {
      if (emailaddress1) {
        this.emailValidation(emailaddress1, setErrorFn);
      } else {
        setErrorFn('emailaddress1', false, null);
        this.setState({ isEmailValid: true });
      }
    }

    if (isPhoneMandatory) {
      if (telephone1) {
        this.phoneValidation(telephone1, setErrorFn);
      }
    } else {
      if (telephone1) {
        this.phoneValidation(telephone1, setErrorFn);
      } else {
        setErrorFn('telephone1', false, null);
        this.setState({ isPhoneValid: true });
      }
    }

    if (isHomePhoneMandatory) {
      if (telephone2) {
        this.homePhoneValidation(telephone2, setErrorFn);
      }
    } else {
      if (telephone2) {
        this.homePhoneValidation(telephone2, setErrorFn);
      } else {
        setErrorFn('telephone2', false, null);
        this.setState({ isHomePhoneValid: true });
      }
    }
  }

  emailValidation = (emailaddress1, setErrorFn) => {
    if (!emailaddress1.match(EMAIL_REGEX.REGEX)) {
      const errorMsgEmail = (
        <span className="error-msg">
          <WarningIcon />
          <b>Invalid Email id</b>
        </span>
      );
      setErrorFn('emailaddress1', true, errorMsgEmail);
      this.setState({ isEmailValid: false });
    } else {
      setErrorFn('emailaddress1', false, null);
      this.setState({ isEmailValid: true });
    }
  };

  phoneValidation = (telephone1, setErrorFn) => {
    if (!telephone1.match(PHONE_REGEX.REGEX)) {
      const errorMsgPhone = (
        <span className="error-msg">
          <WarningIcon />
          <b>Invalid Phone Number</b>
        </span>
      );
      setErrorFn('telephone1', true, errorMsgPhone);
      this.setState({ isPhoneValid: false });
    } else {
      setErrorFn('telephone1', false, null);
      this.setState({ isPhoneValid: true });
    }
  };

  homePhoneValidation = (telephone2, setErrorFn) => {
    if (!telephone2.match(PHONE_REGEX.REGEX)) {
      const errorMsgPhone = (
        <span className="error-msg">
          <WarningIcon />
          <b>Invalid Phone Number</b>
        </span>
      );
      setErrorFn('telephone2', true, errorMsgPhone);
      this.setState({ isHomePhoneValid: false });
    } else {
      setErrorFn('telephone2', false, null);
      this.setState({ isHomePhoneValid: true });
    }
  };

  onSaveForm = ({ formValues, updateValue }) => {};

  handleSave = () => {
    this.setState({ saveDisabled: true });
    const { onSaveForm, enqueueSnackbar, formElements, onModifySaveRequest, onSaveSuccess, attributeName } = this.props;
    const { formValues } = this.state;

    if (!onSaveForm) {
      return;
    }

    const { entityId, organizerInstanceId, organizerTypeId, yearTypeId, pageId } = formElements;

    let payload = {
      entityId,
      organizerInstanceId,
      organizerTypeId,
      yearTypeId,
      pageId,
      languageId: 1,
      ...transformFormValues(formValues),
    };

    if (onModifySaveRequest) {
      payload = onModifySaveRequest(payload);
    }
    if (attributeName !== 'ey_employeeapplicantid') {
      onSaveForm(payload).then(response => {
        this.setState({ saveDisabled: false });
        if (response && response.error) {
          return enqueueSnackbar(response.error.message, { variant: 'error' });
        }
        if (onSaveSuccess) {
          onSaveSuccess(response);
        }
        this.setFormStatus(false);
      });
    } else {
      this.setState({ duplicateEmployeeArray: [] });
      axios
        .post(serviceUrls.EMPLOYEES_GET_DUPLICATE, {
          emailID: payload.dataRequests[1].value,
          employeeID: payload.dataRequests[10].value,
        })
        .then(res => {
          if (res.data.employeeStatus === 'inactive') {
            this.setState({ saveDisabled: false });
            return enqueueSnackbar(intl.get('serviceInit.duplicateEmail.inactive'), { variant: 'error' });
          } else if (res.data.employeeStatus === 'active') {
            this.setState({ duplicateEmployeeArray: res.data.rows, saveDisabled: false, isDuplicateUserSelected: false });
            return enqueueSnackbar(intl.get('serviceInit.duplicateEmail.active'), { variant: 'error' });
          } else if (res.data.employeeStatus === 'new') {
            onSaveForm(payload).then(response => {
              if (onSaveSuccess) {
                onSaveSuccess(response);
              }
              this.setState({ saveDisabled: false });
              this.setFormStatus(false);
            });
          }
        });
    }
  };

  setFormValues = ({ formValues, isFormComplete }) => {
    this.setState({ formValues, isFormComplete });
  };

  handleDuplicateEmployee = () => {
    const restrictedArray = ['Restricted Corporate Member', 'Client Manager'];
    if (restrictedArray.includes(this.state.duplicateUserSelected.contactType)) {
      return this.props.enqueueSnackbar(intl.get('serviceInit.duplicateEmail.restricted'), { variant: 'error' });
    } else {
      this.setState({
        duplicateEmployee: this.state.duplicateUserSelected,
        isDuplicateUserSelected: true,
        duplicateEmployeeArray: [],
      });
      this.setFormStatus(false);
    }
  };

  onChangeDuplicateUser(val) {
    this.setState({
      isDuplicateUserSelected: true,
      duplicateUserSelected: val,
    });
  }

  handleCancel() {
    this.setFormStatus(false);
    this.setState({
      isDuplicateUserSelected: false,
      duplicateEmployeeArray: [],
    });
  }

  handleButtonClick() {
    this.setState({
      isFormShown: true,
    });
  }

  renderMenu = params => {
    const handleClick = () => {
      // triggerClose();
      this.setFormStatus(true);
    };
    return (
      <React.Fragment>
        <components.MenuList {...params} className="select-options-container">
          <span role="status" aria-live="assertive" aria-atomic="true" className="aria-announce">
            {this.props.searchLabel}. {params.options.length} {intl.get('searchAdd.labels.searchMessage')}
          </span>
          {params.children}
        </components.MenuList>
        {this.props.attributeName !== 'ey_hostcompanyid' && this.props.attributeName !== 'ey_employeeapplicantid' && (
          <section className="select-options-footer">
            <button onClick={handleClick}>{this.props.addLabel}</button>
          </section>
        )}
      </React.Fragment>
    );
  };

  render() {
    const { onFilter, onSearch, formElements, defaultValue, noResultsLabel, searchLabel, styleType, getOptionValue, required } = this.props;
    const { isFormComplete, duplicateEmployee } = this.state;
    return (
      <div className="searchadd-container">
        <div>
          <Autocomplete
            label={searchLabel}
            defaultValue={defaultValue}
            multi={false}
            hideIconOnSelect={true}
            styleType={styleType}
            noResultsText={noResultsLabel}
            onChange={this.handleOnChange}
            onFilter={onFilter}
            menuContainerStyle={{
              backgroundColor: '#FFF',
              border: 'none',
            }}
            renderMenu={this.renderMenu}
            loadOptions={onSearch}
            getOptionValue={getOptionValue}
            required={required}
            duplicateEmployee={duplicateEmployee}
          />
        </div>
        <div>
          {this.props.attributeName === 'ey_employeeapplicantid' && (
            <section className="select-options-footer-button">
              <button onClick={() => this.handleButtonClick()}>{this.props.addLabel}</button>
            </section>
          )}
        </div>
        {this.state.isFormShown && formElements && (
          <Dialog
            open
            onClose={() => this.setFormStatus(false)}
            aria-labelledby="dialog-title"
            fullWidth
            maxWidth="md"
            className="largemodal">
            <Fragment>
              <DialogTitle id="dialog-title">
                New Record
                <IconButton aria-label="close" onClick={() => this.handleCancel()} className="close-button">
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                <div className="content">
                  <ContentParser
                    key={formElements.pageId}
                    pageId={formElements.pageId}
                    data={formElements}
                    onChange={this.setFormValues}
                    numberOfColumns={3}
                    forceNumberOfColumns={true}
                    showLabels={false}
                    debug={false}
                    onValidate={this.onValidate}
                  />
                </div>
              </DialogContent>
              {!!this.state.duplicateEmployeeArray.length && (
                <div className="duplicateContainner">
                  <div className="duplicaterows">
                    {this.state.duplicateEmployeeArray.map(v => (
                      <div className="duplicateEmployee">
                        <div className="employee">
                          <div>
                            <input type="radio" name="selectUser" onChange={() => this.onChangeDuplicateUser(v)} />
                          </div>
                          <div className="avtar">
                            <span className="shortname">{`${v.fullName.split(' ')[0][0]}${
                              v.fullName.split(' ')[1] ? v.fullName.split(' ')[1][0] : ''
                            }`}</span>
                          </div>
                          <div>
                            <p>{intl.get('serviceInit.duplicateEmail.employeeName')}</p>
                            <p>{v.fullName}</p>
                          </div>
                        </div>
                        <div className="email">
                          <p>{intl.get('serviceInit.duplicateEmail.email')}</p>
                          <p>{v.email}</p>
                        </div>
                        <div className="employeeId">
                          <p>{intl.get('serviceInit.duplicateEmail.employeeId')}</p>
                          <p>{v.employeeCode}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <Button
                    styleType="primary"
                    onClick={() => this.handleDuplicateEmployee()}
                    className="action-button"
                    disabled={!this.state.isDuplicateUserSelected && 'disabled'}>
                    {intl.get('serviceInit.duplicateEmail.useProfile')}
                  </Button>
                </div>
              )}
              <DialogActions>
                <section className="actions">
                  <div className="save-cancel-wrapper">
                    <Button styleType="secondary" onClick={() => this.handleCancel()} className="action-button">
                      {intl.get('searchAdd.labels.cancel')}
                    </Button>
                    <Button
                      className="action-button"
                      disabled={
                        !isFormComplete ||
                        this.state.saveDisabled ||
                        !this.state.isEmailValid ||
                        !this.state.isPhoneValid ||
                        !this.state.isHomePhoneValid
                      }
                      onClick={this.handleSave}>
                      {intl.get('searchAdd.labels.save')}
                    </Button>
                  </div>
                </section>
              </DialogActions>
            </Fragment>
          </Dialog>
        )}
      </div>
    );
  }
}

export default withSnackbar(SearchAdd);
